/* unplugin-vue-components disabled */import script from "./CrsView.vue?vue&type=script&setup=true&lang=js"
export * from "./CrsView.vue?vue&type=script&setup=true&lang=js"

import "./CrsView.vue?vue&type=style&index=0&id=045bec67&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-045bec67"]])

export default __exports__